import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'app-button',
  imports: [CommonModule, RouterLink, TooltipModule],
  templateUrl: './button.component.html',
})
export class ButtonComponent {
  /**
   * * Outputs
   */
  @Output() handleClick = new EventEmitter<any>();

  /**
   * * Inputs
   */
  @Input() icon = '';
  @Input() type: 'button' | 'submit' = 'button';
  @Input() btnStyle: 'main' | 'second' | 'clear' | 'outlined' = 'main';
  @Input() btnVariant: 'text' | 'outlined' | 'filled' = 'filled';
  @Input() disabled = false;
  @Input() text = '';
  @Input() tooltipTitle = '';
  @Input() tooltipPosition: 'top' | 'left' | 'right' | 'bottom' = 'top';
  @Input() routerLink: any[] | null = null;
  @Input() styleClass = '';
  @Input() size: 'small' | 'normal' = 'normal';

  /* ====================================
  *             MAIN FEATURES
  ======================================= */

  onClickEvent(event: MouseEvent) {
    this.handleClick.emit(event);
  }
}
